module.exports = __webpack_public_path__ + "static/media/concrete-buggy.ce077cb6.jpg";